import { render, staticRenderFns } from "./newUserKeep.vue?vue&type=template&id=a98226d2&scoped=true&"
import script from "./newUserKeep.vue?vue&type=script&lang=js&"
export * from "./newUserKeep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98226d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a98226d2')) {
      api.createRecord('a98226d2', component.options)
    } else {
      api.reload('a98226d2', component.options)
    }
    module.hot.accept("./newUserKeep.vue?vue&type=template&id=a98226d2&scoped=true&", function () {
      api.rerender('a98226d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/userAnalysis/newUserKeep.vue"
export default component.exports